import { CheckCircle, AlertCircle, Clock, RefreshCw } from 'lucide-react'

export const getStatusConfig = (status: string) => {
    switch (status) {
        case 'INDEXED':
            return {
                icon: CheckCircle,
                label: 'INDEXED',
                bg: 'bg-green-500/10',
                bgClass: 'bg-green-500/10',
                color: 'text-green-400',
                textClass: 'text-green-400',
                border: 'border-green-500/20',
                borderClass: 'border-green-500/20',
                animate: false
            }
        case 'PROCESSING':
            return {
                icon: RefreshCw,
                label: 'PROCESSING',
                bg: 'bg-blue-500/10',
                bgClass: 'bg-blue-500/10',
                color: 'text-blue-400',
                textClass: 'text-blue-400',
                border: 'border-blue-500/20',
                borderClass: 'border-blue-500/20',
                animate: true
            }
        case 'FAILED':
            return {
                icon: AlertCircle,
                label: 'FAILED',
                bg: 'bg-red-500/10',
                bgClass: 'bg-red-500/10',
                color: 'text-red-400',
                textClass: 'text-red-400',
                border: 'border-red-500/20',
                borderClass: 'border-red-500/20',
                animate: false
            }
        case 'PENDING':
            return {
                icon: Clock,
                label: 'PENDING',
                bg: 'bg-yellow-500/10',
                bgClass: 'bg-yellow-500/10',
                color: 'text-yellow-400',
                textClass: 'text-yellow-400',
                border: 'border-yellow-500/20',
                borderClass: 'border-yellow-500/20',
                animate: false
            }
        default:
            return {
                icon: Clock,
                label: 'UNKNOWN',
                bg: 'bg-gray-500/10',
                bgClass: 'bg-gray-500/10',
                color: 'text-gray-400',
                textClass: 'text-gray-400',
                border: 'border-gray-500/20',
                borderClass: 'border-gray-500/20',
                animate: false
            }
    }
}
